// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2WrD_","disabled":"FileBtn_disabled__3hiGc","warn":"FileBtn_warn__3Nel1","fade":"FileBtn_fade__mWMn4"};